import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import setDomainState from '../mutators/setDomainState';
import setIsValidatingDomain from '../mutators/setIsValidatingDomain';
import { validateDomain } from '../actions/validateDomain';
import { validateDomain as validateDomainService } from '../services/validateDomain';
export default orchestrator(validateDomain, function validateDomain() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsValidatingDomain(true);
                    return [4 /*yield*/, validateDomainService()];
                case 1:
                    response = _a.sent();
                    setDomainState(response);
                    setIsValidatingDomain(false);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=validateDomain.js.map